<template>
  <v-dialog v-model="dialog" persistent width="1600">
    <v-card>
      <v-card-title>Inserir notas do ENEM - {{ ps.title }}</v-card-title>
      <v-card-text>
        <v-row v-if="isAdmin" class="mt-1">
          <v-col>
            <v-file-input
              dense
              outlined
              hide-details="auto"
              label="Planilha de notas"
              v-model="enem.sheet"
              :disabled="sending"
            ></v-file-input>
          </v-col>
        </v-row>
        <v-row class="mt-2 mb-4">
          <v-col>
            <v-text-field
              dense
              outlined
              hide-details="auto"
              label="Insira o ano do ENEM"
              v-model="enem.year"
              :disabled="sending"
            ></v-text-field>
          </v-col>
        </v-row>
        <div v-if="sending || sent">
          <v-row>
            <v-col v-if="sending">
              Salvando as notas. Por favor, aguarde.
            </v-col>
            <v-col v-else> Concluído. Notas salvas com sucesso. </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-progress-linear
                v-if="totalItems > 0"
                :value="progressPercent"
                striped
                height="20"
                color="blue"
              >
                {{ progressPercent }}%
              </v-progress-linear>
              <v-progress-linear
                v-else
                indeterminate
                striped
                height="20"
              ></v-progress-linear>
            </v-col>
          </v-row>
        </div>
        <div v-if="result.diffName.length > 0">
          <v-row>
            <v-col>
              <h4>Usuários com conflito no nome</h4>
            </v-col>
          </v-row>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>NÚMERO DE INSCRIÇÃO</th>
                  <th>CPF</th>
                  <th>NOME NO SISTEMA</th>
                  <th>NOME NO INEP</th>
                  <th>CIÊNCIAS DA NATUREZA</th>
                  <th>CIÊNCIAS HUMANAS</th>
                  <th>LINGUAGENS</th>
                  <th>MATEMÁTICA</th>
                  <th>REDAÇÃO</th>
                  <th>APROVAR</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(inscription, index) in result.diffName"
                  :key="index"
                >
                  <td>
                    {{ inscription.inepNumber }}
                  </td>
                  <td>
                    {{ inscription.cpf }}
                  </td>
                  <td>
                    {{ inscription.nameInscription }}
                  </td>
                  <td>
                    {{ inscription.nameSheet }}
                  </td>
                  <td>
                    {{ inscription.gradeCience }}
                  </td>
                  <td>
                    {{ inscription.gradeHumans }}
                  </td>
                  <td>
                    {{ inscription.gradeLanguage }}
                  </td>
                  <td>
                    {{ inscription.gradeMath }}
                  </td>
                  <td>
                    {{ inscription.gradeText }}
                  </td>
                  <td>
                    <v-icon
                      :color="inscription.approve ? 'green' : 'red'"
                      @click="approve(inscription)"
                      >mdi-pen</v-icon
                    >
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <!-- <v-row v-for="(inscription, index) in result.diffName" :key="index">
            <v-col>{{ inscription }}</v-col>
          </v-row> -->
        </div>
      </v-card-text>
      <v-card-actions class="pb-6 pr-6">
        <v-spacer></v-spacer>
        <v-btn
          :disabled="sending"
          elevation="0"
          color="secondary"
          dark
          @click="close"
        >
          Fechar
        </v-btn>
        <v-btn
          :disabled="sending"
          elevation="0"
          color="primary"
          @click="openPasswordDialog"
        >
          Enviar
        </v-btn>
      </v-card-actions>
    </v-card>
    <ConfirmDialog
      v-if="confirmDialog"
      :dialog="confirmDialog"
      @close="confirmDialog = false"
      @result="insertEnemGrades"
    />
  </v-dialog>
</template>

<script>
import { app, socketApp } from "../services/feathers";
import xlsx from "xlsx";
import { saveAs } from "file-saver";
import formatCPF from "../utils/formatCpf";
import { mapGetters } from "vuex";
import ConfirmDialog from "./ConfirmDialog";

export default {
  props: ["dialog", "ps"],
  components: {
    ConfirmDialog,
  },
  computed: {
    ...mapGetters("auth", ["isAuthenticated", "isAdmin", "isStaff"]),
  },
  data() {
    return {
      confirmDialog: false,
      sent: false,
      sending: false,
      totalItems: 0,
      processedItems: 0,
      progressPercent: 0,
      taskId: null,
      result: { cpfNotFound: [], diffName: [], success: [] },
      enem: { sheet: undefined, year: undefined },
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    async approve(item) {
      if (!item.approve) {
        try {
          const inscription = await app.service("inscriptions").get(item._id);
          const data = {
            year: this.enem.year,
            gradeCience: item["gradeCience"],
            gradeHumans: item["gradeHumans"],
            gradeLanguage: item["gradeLanguage"],
            gradeMath: item["gradeMath"],
            gradeText: item["gradeText"],
          };
          let enemArr = undefined;

          if (inscription.enem) {
            const repeated = inscription.enem.findIndex(
              (e) => e.year === this.enem.year
            );
            if (repeated > -1) {
              inscription.enem[repeated] = data;
              enemArr = inscription.enem;
            } else enemArr = [data, ...inscription.enem];
          } else {
            enemArr = [];
            enemArr.push(data);
          }
          await app
            .service("inscriptions")
            .patch(inscription._id, { enem: enemArr, id_ps: this.ps._id });
          item.approve = true;
        } catch (error) {
          //
          console.log(error);
        }
      }
    },
    openPasswordDialog() {
      this.confirmDialog = true;
    },
    insertEnemGrades(result) {
      if (result) {
        this.confirmDialog = false;
        const columns = {
          cpf: "CPF",
          name: "NOME",
          gradeCience: "Nota Ciências da Natureza e suas Tecnologias",
          gradeHumans: "Nota Ciências Humanas e suas Tecnologias",
          gradeLanguage: "Nota Linguagens,Códigos e suas Tecnologias",
          gradeMath: "Nota Matemática e suas Tecnologias",
          gradeText: "Nota Redação",
        };
        const reader = new FileReader();
        this.sending = true;
        this.totalItems = 0;
        this.processedItems = 0;
        this.progressPercent = 0;

        reader.onload = async () => {
          let workbook = xlsx.read(reader.result, { type: "binary" });
          let sheet = workbook.SheetNames[0];
          let sheetJson = xlsx.utils.sheet_to_json(workbook.Sheets[sheet], {});

          // Normaliza os CPFs
          sheetJson = sheetJson.map((e) => {
            e[columns.cpf] = ("" + e[columns.cpf]).replace("-", "");
            if (e[columns.cpf].length < 11) {
              const dif = 11 - e[columns.cpf].length;
              let text = "";
              for (let index = 0; index < dif; index++) {
                text += "0";
              }
              e[columns.cpf] = text + e[columns.cpf];
            }
            return e;
          });

          // Iniciar o processamento com SSE
          this.startProcessing({
            id_ps: this.ps._id,
            sheet: sheetJson,
            year: this.enem.year,
          });
        };

        reader.readAsBinaryString(this.enem.sheet);
      }
    },
    startProcessing(payload) {
      this.sending = true;
      this.totalItems = 0;
      this.processedItems = 0;
      this.progressPercent = 0;

      console.log("Iniciando processamento, payload:", payload);

      // Chama o serviço `set-enem` para iniciar o processamento
      app
        .service("set-enem")
        .create(payload)
        .then(async (response) => {
          console.log("Task criada com sucesso:", response);

          this.taskId = response.taskId;

          if (!this.taskId) {
            console.error("Erro: taskId não foi retornado!");
            this.sending = false;
            return;
          }

          // Inscreve-se no canal específico da tarefa
          socketApp.service("mensagem-progresso").on(`created`, (data) => {
            if (data.taskId === this.taskId) {
              console.log("Atualização de progresso:", data);

              this.progressPercent = data.progress.toFixed(2);
              this.processedItems = data.processedItems;
              this.totalItems = data.totalItems;

              if (data.status === "completed") {
                this.sent = true;
                this.sending = false;
              }

              if (data.status === "error") {
                console.error("Erro no processamento!");
                this.sending = false;
              }
            }
          });
        })
        .catch((error) => {
          console.error("Erro ao iniciar o processamento:", error);
          this.sending = false;
        });
    },
    generateGradeXls(data) {
      data.cpfNotFound = data.cpfNotFound?.map((e) => this.fixToGradeXlsx(e));
      data.diffName = data.diffName?.map((e) => this.fixToGradeXlsx(e));
      data.success = data.success?.map((e) => this.fixToGradeXlsx(e));
      let planilha = xlsx.utils.book_new();
      let cabecalho = [
        ["NOME NO SISTEMA", "NOME NA PLANILHA", "CPF", "ANO DO ENEM"],
      ];
      planilha.SheetNames.push("BEM SUCEDIDOS");
      planilha.Sheets["BEM SUCEDIDOS"] = xlsx.utils.aoa_to_sheet([
        ...cabecalho,
        ...data.success,
      ]);
      planilha.SheetNames.push("NOMES DIFERENTES");
      planilha.Sheets["NOMES DIFERENTES"] = xlsx.utils.aoa_to_sheet([
        ...cabecalho,
        ...data.diffName,
      ]);
      planilha.SheetNames.push("CPF NÃO ENCONTRADO");
      planilha.Sheets["CPF NÃO ENCONTRADO"] = xlsx.utils.aoa_to_sheet([
        ...cabecalho,
        ...data.cpfNotFound,
      ]);
      planilha.SheetNames.push("CPF NÃO ENCONTRADO 2");
      planilha.Sheets["CPF NÃO ENCONTRADO 2"] = xlsx.utils.aoa_to_sheet([
        ...cabecalho,
        ...data.cpfNotFound,
      ]);
      let wbout = xlsx.write(planilha, { bookType: "xls", type: "binary" });
      saveAs(
        new Blob([this.s2ab(wbout)], { type: "application/octet-stream" }),
        `${this.ps.title} - notas cadastradas.xls`
      );
    },
    s2ab(s) {
      var buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
      var view = new Uint8Array(buf); //create uint8array as viewer
      for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff; //convert to octet
      return buf;
    },
    fixToGradeXlsx(e) {
      e.cpf = formatCPF(e.cpf);
      return [e.nameInscription, e.nameSheet, e.cpf, e.year];
    },
  },
};
</script>
<style>
</style>